module.exports = __webpack_public_path__ + "static/media/image1.c2bc5e2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/VipRoom/images/image1.jpg
// module id = 439
// module chunks = 0